<template>
<b-container fluid>
  <b-row>
    <b-col>
      <h3>Large Item Shipping</h3>
    </b-col>
  </b-row>
  <b-btn @click="visible = !visible">{{ visible ? 'Hide' : 'Show' }} Item Editor</b-btn>
  <b-collapse v-model="visible" id="collapse" class="my-2">
    <span>Comma seperated or newline seperated</span>
    <b-form-textarea placeholder="Items" v-model="itemFilter" />
    <b-btn variant=warning class="mt-1" style="float: left;" @click="saveSearch">SAVE Search</b-btn>
    <b-btn variant=primary class="mt-1" style="float: right;" @click="search">Search!</b-btn>
  </b-collapse>
  <b-row class='my-3'>
    <b-col>
      <b-table :items="productInfo">
        <template slot="length" slot-scope="data">
          <b-input v-model="data.item.length" :disabled="!data.item.custom" />
        </template>
        <template slot="custom" slot-scope="data">
          <span v-if="data.item.custom" v-b-popover.hover="'This product has missing dimensions in fishbowl! You need to fill these in manually.'"><i class="fas fa-question-circle"></i></span>
          <span v-else></span>
        </template>
        <template slot="width" slot-scope="data">
          <b-input v-model="data.item.width" :disabled="!data.item.custom" />
        </template>
        <template slot="height" slot-scope="data">
          <b-input v-model="data.item.height" :disabled="!data.item.custom" />
        </template>
        <template slot="weightOz" slot-scope="data">
          <b-input v-model="data.item.weightOz" :disabled="!data.item.custom" />
        </template>
      </b-table>
    </b-col>
  </b-row>
  <b-row v-if="count > 0" class="mb-2">
    <b-col>
      <b-btn style="float: right" variant="primary" @click="sendItems">Ship {{ count }} Selected</b-btn>
    </b-col>
  </b-row>
  <b-row v-if="allClear">
    <b-col>
      <b-table :items="items" :fields="fields">
        <template slot="orderNum" slot-scope="data">
          <router-link :to="{ name: 'View Order', params: { id: data.item.orderNum }}" target="_blank">
            {{ data.item.orderNum }}
          </router-link>
        </template>
        <template slot="notes" slot-scope="data">
          {{ data.item.orderNote }}
          {{ data.item.itemNote }}
        </template>
        <template slot="customerAccount" slot-scope="data">
          <b-input-group>
            <b-input-group-prepend is-text v-if="data.item.orderNote.includes('customer') || data.item.orderNote.includes('account')">
              <span><i class="fas fa-exclamation-circle"></i></span>
            </b-input-group-prepend>
            <b-form-input :v-model="data.item.customerAccount" />
          </b-input-group>
        </template>
        <template slot="check" slot-scope="data">
          <b-form-checkbox v-model="data.item.check" @input="checkboxChanged" />
        </template>
      </b-table>
    </b-col>
  </b-row>


<b-modal
  ref="requestModalRef"
  size=xl
  show
  :title="modalTitle"
  scrollable
  :no-close-on-backdrop="waitingOnChamp"
  :no-close-on-esc="waitingOnChamp"
  :hide-header-close="waitingOnChamp"
  :hide-footer="waitingOnChamp"
>
  <b-table :items="requests" :fields="['order', 'item', 'complete']">
    <template slot="order" slot-scope="data">
      <span v-b-popover.click="data.item.uuid" v-b-popover.hover="data.item.uuid">{{ data.item.order }}</span>
    </template>
    <template slot="complete" slot-scope="data">
      <div v-if="data.item.complete">
        <span v-if="data.item.error"><i class="fas fa-exclamation-circle"></i></span>
        <span v-else><i class="fas fa-check"></i></span>
        <span>{{ data.item.message }}</span>
      </div>
      <span v-else><fingerprint-spinner :animation-duration="1500" :size="30" color="#293a93" /></span>
    </template>
  </b-table>
  <template slot="modal-footer" slot-scope="modal">
    <b-btn variant="primary" @click="$refs.requestModalRef.hide()">Close</b-btn>
  </template>
</b-modal>
</b-container>
</template>

<script>
import axios from 'axios';
import utility from '../../helpers/utility'
import { FingerprintSpinner } from 'epic-spinners';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      visible: false,
      itemFilter: undefined,
      count: 0,
      fields: [
        { key: 'orderNum', label: 'Order #', sortable: true },
        { key: 'productNum', label: 'Product', sortable: true },
        { key: 'description', sortable: true, },
        { key: 'qtytofulfill', label: 'Qty. to Fulfill', sortable: true },
        { key: 'notes', sortable: true },
        { key: 'customerAccount', sortable: true },
        { key: 'check', label: 'Send?' },
      ],
      items: [],
      productInfo: [],

      requests: [],
    }
  },
  mounted() {
    axios.get(`${BASE_API}/settings/large-item-shipping-nums`).then(response => {
      this.itemFilter = response.data.data
      this.search();
    })
  },
  components: {
    FingerprintSpinner,
  },
  computed: {
    allClear() {
      return this.productInfo.filter(x => !x.length || !x.width || !x.height || !x.weightOz).length == 0
    },
    waitingOnChamp() {
      return this.requests.filter(r => !r.complete).length > 0
    },
    modalTitle() {
      return this.waitingOnChamp ? "Shipping..." : "Shipped!"
    },
    modalVariant() {
      return this.waitingOnChamp ? undefined : 'success'
    }
  },
  methods: {
    search() {
      let list = this.cleanSearch().split(',');
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/order/with-items`,
        data: list
      }).then((response) => {
        this.items = response.data
        this.items.forEach(item => item['check'] = false)

        this.productInfo = []
        list.forEach(num => {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i]['productNum'] == num) {
              let item = {
                num: this.items[i]['productNum'],
                length: this.items[i]['len'],
                width: this.items[i]['width'],
                height: this.items[i]['height'],
                weightOz: this.items[i]['weightOz']
              }
              item.custom = !item.length || !item.width || !item.height || !item.weightOz
              this.productInfo.push(item)
              return
            }
          }
        })
      }).catch((error) => {
        console.error(error);
      })
    },
    cleanSearch() {
      return this.itemFilter.replace("\n",",").replace('\r','').replace('\t', '')
    },
    saveSearch() {
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/settings/large-item-shipping-nums`,
        data: this.cleanSearch()
      }).then((response) => {
        console.log(response)
      }).catch((error) => {
        console.error(error);
      })
    },
    async sendItems() {
      this.requests = await Promise.all(this.items.filter(x => !!x.check).map(async x => {
        let pi = this.productInfo.filter(y => y.num == x.productNum)[0]
        return axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/champ/single-ship-item`,
          data: {
            soNumber: x.orderNum,
            customerShippingAccount: x.customerAccount,
            item: {
              soItemId: x.soItemId,
              quantity: x.qtytofulfill,
              height: pi.height,
              length: pi.length,
              width: pi.width,
              weightOz: pi.weightOz,
            },
          },
        }).then(response => {
          return { uuid: response.data, order: x.orderNum, item: x.productNum, complete: false, error: false, message: undefined }
        }).catch(error => {
          console.error(error);
        })
      }));

      this.$refs.requestModalRef.show()

      this.requests.forEach(request => {
        utility.waitResponse(request.uuid, (response) => {
          request.complete = true
          request.message = "Success!"
        }, (response) => {
          request.complete = true
          request.error = true
          request.message = response.Response
        }, () => {
          request.complete = true
          request.error = true
          request.message = "Error (DO NOT RE-SUBMIT): Request Timed Out.... Contact IT for more information."
        }, (error) => {
          request.complete = true
          console.error(error);
          request.error = true
          request.message = "Error (DO NOT RE-SUBMIT): Fetching response failed.... Contact IT for support."
        })
      })
    },
    checkboxChanged(val) {
      this.count += !!val ? 1 : -1
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ops-info/LargeItemShipping.vue